import { createFileRoute } from '@tanstack/react-router';

import { StaffDetail } from '@/features/staff/StaffDetail';

export const Route = createFileRoute('/_authenticated/company/staff/$staffId')({
  component: function CompanyStaffDetailPage() {
    const { staffId } = Route.useParams();
    return <StaffDetail staffId={staffId} backTo='/company/staff' />;
  },
});
